import { waitForElem } from '../../utils/wait_for_elem';

const clear_form_selector = '#send-a-message-form #clear-form';

waitForElem(clear_form_selector).then((matchedElems: NodeListOf<HTMLElement>) => {
  if (matchedElems) {
    // Define the handler separately so we can remove it if needed
    const clearFormHandler = () => {
      const form = document.getElementById('send-a-message-form') as HTMLFormElement | null;
      form?.reset();
    };

    // Remove any existing click listeners for this handler
    matchedElems.forEach(elem => {
      elem.removeEventListener('click', clearFormHandler);
      elem.addEventListener('click', clearFormHandler);
    });
  }
});
